export default __webpack_public_path__ + "static/media/aiec_tv_4.8c563742.svg";